import { useSearchParams } from "react-router-dom";
import { useRef, useState, useEffect } from "react";
import html2canvas from "html2canvas";
import Guideline from "../Components/WinningPage/Guideline";
import { Download } from "lucide-react";
import weuLogo from "../assets/weu-guidel-logo.png";

function WinningPreviewPage() {
  const [searchParams] = useSearchParams();
  const [previewData, setPreviewData] = useState<any>(null);
  const [isDownloading, setIsDownloading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const data = searchParams.get("q");
    if (data) {
      try {
        // Decode base64 with proper UTF-8 handling
        const decodedString = decodeURIComponent(escape(atob(data)));
        const decodedData = JSON.parse(decodedString);
        
        // Transform the data to match expected format
        if (decodedData.posting_keyword_guidelines_list) {
          decodedData.posting_keyword_guidelines = JSON.stringify(
            decodedData.posting_keyword_guidelines_list
          );
          delete decodedData.posting_keyword_guidelines_list;
        }
        
        setPreviewData(decodedData);
        setError(null);
      } catch (error) {
        console.error("Failed to decode preview data:", error);
        setError("미리보기 데이터를 불러올 수 없습니다. URL이 올바른지 확인해주세요.");
        setPreviewData(null);
      }
    } else {
      setError("미리보기 데이터가 없습니다.");
    }
  }, [searchParams]);

  const handleDownload = async () => {
    if (!contentRef.current || !previewData) return;

    setIsDownloading(true);
    try {
      const canvas = await html2canvas(contentRef.current, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
        logging: false,
        windowHeight: contentRef.current.scrollHeight,
        height: contentRef.current.scrollHeight,
      });

      canvas.toBlob((blob) => {
        if (blob) {
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `${previewData.title || "가이드라인"}.jpg`;
          a.click();
          URL.revokeObjectURL(url);
        }
      }, "image/jpeg", 0.95);
    } catch (error) {
      console.error("Failed to capture screenshot:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  if (error || !previewData) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center p-8 bg-white rounded-lg shadow-md max-w-md">
          <div className="mb-4">
            <svg className="mx-auto h-12 w-12 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">미리보기 오류</h2>
          <p className="text-gray-600 mb-4">{error || "미리보기 데이터를 불러올 수 없습니다."}</p>
          <button
            onClick={() => window.history.back()}
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors"
          >
            돌아가기
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-[600px] mx-auto">
        <div ref={contentRef} className="pb-20 p-4">
          <div className="flex justify-center mb-6">
            <img src={weuLogo} alt="위유 로고" className="h-12" />
          </div>
          <Guideline 
            onNext={() => {}} 
            guideline={previewData} 
            isPreview={true}
          />
        </div>
      </div>
      
      {/* Fixed Download Button */}
      <div className="fixed z-20 bottom-0 left-0 right-0 bg-white border-t px-4 py-3 max-w-[600px] mx-auto">
        <button
          onClick={handleDownload}
          disabled={isDownloading}
          className="w-full flex items-center justify-center gap-2 bg-[#0F1E6C] text-white rounded-full h-11 font-semibold disabled:opacity-50"
        >
          <Download className="w-4 h-4" />
          {isDownloading ? "다운로드 중..." : "JPG로 다운로드"}
        </button>
      </div>
    </div>
  );
}

export default WinningPreviewPage;